import { createAction } from "@reduxjs/toolkit";

const showModalLogout = createAction(' modalLogout/showModal');

export default showModalLogout;
